// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  email: string;
  role: number;
  notificationID: string | number;
}

export function useRemoveRoleUserMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function removeRole(params: paramsType): Promise<any> {
    const response = await api.delete<any>(
      `admin/removerole/${params.email}/${params.role}`
    );

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: removeRole,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
